function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "ntm_maine_menu");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Fordypningsskjermer",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "06_artikkelmal",
  transform: "translate(-1810.000000, -60.000000)",
  fill: "#F0AB00"
}, React.createElement("g", {
  id: "btn_maine_menu",
  transform: "translate(1810.000000, 60.000000)"
}, React.createElement("g", {
  id: "noun_1384467_FFFFFF"
}, React.createElement("path", {
  d: "M39.4405594,7.32394366 L3.63636364,7.32394366 C1.62237762,7.32394366 0,5.69014085 0,3.66197183 C0,1.63380282 1.62237762,0 3.63636364,0 L39.4405594,0 C41.4545455,0 43.0769231,1.63380282 43.0769231,3.66197183 C43.0769231,5.69014085 41.4545455,7.32394366 39.4405594,7.32394366 Z M43.0769231,20 C43.0769231,17.971831 41.4545455,16.3380282 39.4405594,16.3380282 L3.63636364,16.3380282 C1.62237762,16.3380282 0,17.971831 0,20 C0,22.028169 1.62237762,23.6619718 3.63636364,23.6619718 L39.4405594,23.6619718 C41.4545455,23.6619718 43.0769231,22.028169 43.0769231,20 Z M43.0769231,36.3380282 C43.0769231,34.3098592 41.4545455,32.6760563 39.4405594,32.6760563 L3.63636364,32.6760563 C1.62237762,32.6760563 0,34.3098592 0,36.3380282 C0,38.3661972 1.62237762,40 3.63636364,40 L39.4405594,40 C41.4545455,40 43.0769231,38.3661972 43.0769231,36.3380282 Z",
  id: "Shape",
  fillRule: "nonzero"
})))));

var SvgHamburger = function SvgHamburger(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "44px",
    height: "40px",
    viewBox: "0 0 44 40",
    ref: svgRef
  }, props), title === undefined ? _ref2 : React.createElement("title", null, title), _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHamburger, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hamburger.bd4dd5af.svg";
export { ForwardRef as ReactComponent };